import React from "react";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import ReCaptchaComponent from "../../ReCaptcha/ReCaptchaComponent";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";

const LoginDetailForm = (props) => {
  return (
    <Formik
      initialValues={{ email: "", password: "", captchaValue: null }}
      validationSchema={validationSchema.LoginSchema}
      onSubmit={(values) => props?.submitLogin(values)}
    >
      {(formik) => (
        <Form className="form-container">
          <FormikTextField
            label="EMAIL ADDRESS"
            formik={formik}
            fieldName="email"
            placeholder="Enter Email Address"
            labelFontSize="fs-18"
            type="email"
            customClassNames="formik-input-field instn fs-20 semi-bold w-100 olnone share-popup-input fmlabel black "
          />
          <FormikTextField
            label="PASSWORD"
            formik={formik}
            fieldName="password"
            placeholder="Enter Your Password"
            labelFontSize="fs-18"
            type="password"
            customClassNames="formik-input-field instn fs-20 semi-bold w-100 olnone share-popup-input fmlabel black "
          />

          <Link className="forgot-link-container" to="/forgotpassword">
            <div className="mg-left-auto">Forgot Password</div>
          </Link>

          <ReCaptchaComponent
            setCaptchaValue={(value) =>
              formik.setFieldValue("captchaValue", value)
            }
          />

          <div
            className={`form-item form-button-item ${
              !formik.isValid ? "opacity07" : ""
            }`}
          >
            <button disabled={!formik.isValid}>Login</button>
          </div>
          <div className="not-registered">
            Not Registered?
            <Link className="forgot-link-container" to="/signup">
              <div>Sign Up</div>
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export const LoginForm = LoginDetailForm;
